const he = {
  loginTitle: 'כניסה',
  loginPlaceholderID: 'תעודת הזהות',
  loginPlaceholderPassword: 'סיסמה',
  loginPlaceholderEmail: 'כתובת אימייל',
  loginBtn: 'כניסה',
  loginGetPassocdeBtn: 'קבל קוד',
  loginGetPassocde: 'הזמת קוד זמני',
  loginGoToLogin: 'חזור לכניסה',
  // welcome page
  WelcomeMassage: 'שלום',
  Welcome1Massage: 'אנו שמחים לראות אותך',
  //comleted page
  Thankyou: 'תודה על השתתפותכם בשאלון',
  Back: 'חזור',
}

export default he
